import { useCallback } from 'react'

import PlainButton from 'app/common/ui-next/plain-button'
import { PlainConfirm } from 'app/common/ui-next/plain-confirm-modal'
import useCallbackRef from 'app/common/hooks/useCallbackRef'

import styles from './Actions.scss'


type Props = {
  ID: string
  disabled?: boolean
  onRemove?: (ID: string) => void
  onEdit?: (ID: string) => void
}

export const Actions = ({ ID, disabled, onRemove, onEdit }: Props) => {
  const onRemoveRef = useCallbackRef(onRemove)
  const handleRemove = useCallback(async () => {
    onRemoveRef.current?.(ID)
    return true
  }, [onRemoveRef, ID])

  return (
    <>
      {onRemove
        && <PlainConfirm
          messageText={`Удалить заявку с номером ${ID}?`}
          onConfirm={handleRemove}
          closeRightAway
        >
          {beginConfirmation => (
            <PlainButton
              onClick={beginConfirmation}
              className={styles.actionButton}
              disabled={disabled}
              compact
            >
              {'Удалить'}
            </PlainButton>
          )}
        </PlainConfirm>}
      {onEdit
        && <PlainButton
          onClick={() => onEdit(ID)}
          className={styles.actionButton}
          disabled={disabled}
          compact
        >
          {'Редактировать'}
        </PlainButton>}
    </>
  )
}
